import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { SharedDataService } from 'ngx-paf-common';
import { AuthState } from 'src/app/Models_Extranet/AuthState';

@Component({
  selector: 'logged-callback',
  template: '<span></span>',
  styleUrls: []
})
export class LoginCallbackComponent implements OnInit {

  constructor(
    private oauthService: OAuthService,
    private router: Router,
    private route: ActivatedRoute,
    public sharedDataSvc: SharedDataService) {

  }

  async ngOnInit() {
    let urls = await this._checkRedirectPage();
    urls && this.router.navigate(urls);
  }


  private _checkRedirectPage(): Promise<string[]> {
    return new Promise<string[]>(async (resolve) => {
      this._checkAuthenticationState()
        .then((isAuthenticated) => {
          if (!isAuthenticated) {
            resolve(['/home']);
            return;
          }
          if (!!this.oauthService.state) {
            const state: string = decodeURIComponent(this.oauthService.state);
            const params = new URLSearchParams(state);
            const encoded = params.get('pafState');

            if (encoded) {
              const decoded = decodeURIComponent(encoded);
              const pafState: AuthState = JSON.parse(decoded);
              resolve(pafState.url.split(','));
              return;
            }
          }
          resolve([`suppliers`]);
        },
          (error) => resolve(['/home'])
        );
    });
  }

  private _checkAuthenticationState(): Promise<boolean> {
    return new Promise((resolve) => {
      this.oauthService.loadDiscoveryDocument().then(() => {
        this.oauthService.tryLogin()
          .then((result) => {
            if (this.oauthService.hasValidAccessToken()) {
              resolve(true);
            } else {
              resolve(false);
            }
          },
            (error) => resolve(error.statusText =='OK'));
      },
        () => resolve(false)
      );
    });
  }
}
